import { render, staticRenderFns } from "./BoxFiles.vue?vue&type=template&id=d40caa02"
import script from "./BoxFiles.vue?vue&type=script&lang=js"
export * from "./BoxFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports